import { AnyAction } from 'redux';
import { SET_TAKEN_IDENTIFIERS, SET_TICKET } from 'src/redux/actions/ticketActions';
import { TicketModel } from 'src/models/TicketModel';

export interface TicketsState {
  takenIdentifiers: string[];
  entities: Record<number, TicketModel>;
}

const DEFAULT: TicketsState = {
  takenIdentifiers: [],
  entities: {},
};

const TicketsReducer = (state = DEFAULT, action: AnyAction): TicketsState => {
  switch (action.type) {
    case SET_TAKEN_IDENTIFIERS:
      return {
        ...state,
        takenIdentifiers: action.payload as string[],
      };
    case SET_TICKET: {
      const ticket = action.payload as TicketModel;
      return {
        ...state,
        // `entities` is absent from state persisted before this key existed, so default it here.
        entities: {
          ...(state.entities || {}),
          [ticket.id]: ticket,
        },
      };
    }
    default:
      return state;
  }
};

export default TicketsReducer;
